import { render, staticRenderFns } from "./Screen1.vue?vue&type=template&id=276da6b6&lang=html&"
import script from "./Screen1.vue?vue&type=script&lang=js&"
export * from "./Screen1.vue?vue&type=script&lang=js&"
import style0 from "./Screen1.vue?vue&type=style&index=0&id=276da6b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports